<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<offer-request />
					<div class="h-3 grid justify-items-center">
						<div class="max-w-[1600px]">
							<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
						</div>
					</div>
					<panel :title="$t('eny.expenses')" addclass="mt-4">
						<form id="expenses-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Living condition types -->
									<validation cssClass="w-full max-w-text">
										<ejs-combobox id='cust_living_condition' name='cust_living_condition' :dataSource='living_condition_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.living_condition')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.living_condition"></ejs-combobox>
									</validation>
									<!-- Monthly housing expenses -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="cust_monthly_housing_expenses" name="cust_monthly_housing_expenses" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.monthly_housing_expenses')" v-model:value="request_loc.housing_expenses"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Housing type title -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.housing_type')}}</p>
									</div>
									<!-- Housing type -->
									<validation cssClass="w-full max-w-text pt-1">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_housing_rent" name="housing_property" value='1' v-model="request_loc.housing_property" />
												<label for="radio_housing_rent"><span>{{$t('eny.rent')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_housing_property" name="housing_property" value='2' v-model="request_loc.housing_property" />
												<label for="radio_housing_property"><span>{{$t('eny.property')}}</span></label>
											</div>
										</div>
									</validation>
									<!-- Customer health insurance -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="cust_health_insurance" name="cust_health_insurance" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.health_insurance')" v-model:value="request_loc.health_insurance"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Question Customer costs out of town meals -->
									<div class="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.costs_out_of_town_meals')}}</p>
									</div>
									<!-- Customer costs out of town meals -->
									<validation cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="cust_costs_out_of_town_meals_1" name="cust_costs_out_of_town_meals" value='1' v-model="request_loc.costs_out_of_town_meals" />
												<label for="cust_costs_out_of_town_meals_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="cust_costs_out_of_town_meals_0" name="cust_costs_out_of_town_meals" value='0' v-model="request_loc.costs_out_of_town_meals" />
												<label for="cust_costs_out_of_town_meals_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
									<!-- Customer transport to work type -->
									<validation cssClass="w-full max-w-text">
										<ejs-combobox id='cust_transport_to_work_type' name='cust_transport_to_work_type' :dataSource='transport_to_work_types' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.means_of_transport_to_work')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.transport_to_work_type"></ejs-combobox>
									</validation>
								</div>
							</div>
						</form>
					</panel>
					<panel :title="$t('eny.existing_obligations')" addclass="mt-4">
						<form id="existing-obligations-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Question open loan -->
									<div class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.question_open_loan')}}</p>
									</div>
									<!-- Has open loan -->
									<validation cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_has_open_loan_1" name="cust_has_open_loan" value='1' v-model="request_loc.has_open_loan" />
												<label for="radio_has_open_loan_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_has_open_loan_0" name="cust_has_open_loan" value='0' v-model="request_loc.has_open_loan" />
												<label for="radio_has_open_loan_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
									<!-- open loans -->
									<div v-show="request_loc.has_open_loan == 1" class="w-full max-w-text">
										<div v-for="(open_loan, nr) in open_loans_loc" :key="nr" class="p-2 m-1 mt-4 border-3 rounded-3xl border-color-2">
											<!-- Bank -->
											<validation>
												<div class="flex flex-row gap-2 items-end">
													<ejs-combobox :name="'cust_loan_bank_' + nr" :dataSource='banks' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.bank') + ' ' + (nr + 1)" :showClearButton="false" :allowCustom="false" v-model:value="open_loan.bank"></ejs-combobox>
													<button type="button" class="eny-btn-blue px-4 pb-1 h-10 font-semibold text-2xl" @click="deleteOpenLoan(nr)">x</button>
												</div>
											</validation>
											<!-- Month rate -->
											<validation>
												<div class="flex flex-row">
													<ejs-numerictextbox :id="'cust_monthly_rate_' + nr" :name="'cust_monthly_rate_' + nr" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.monthly_rate')" v-model:value="open_loan.month_rate"></ejs-numerictextbox>
													<text-box-extension :label="$t('eny.chf')" />
												</div>
											</validation>
											<!-- Open balance -->
											<validation>
												<ejs-numerictextbox :id="'cust_open_balance_' + nr" :name="'cust_open_balance_' + nr" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.open_balance')" v-model:value="open_loan.open_balance"></ejs-numerictextbox>
											</validation>
										</div>
										<!-- Additional open loan -->
										<div v-show="open_loans_loc.length < 3" class="w-full px-10 md:px-20 pt-5 flex flex-row justify-center">
											<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addOpenLoan">{{$t('eny.other_existing_credit')}}</button>
										</div>
									</div>
									<!-- Open credit card balance -->
									<!-- Question open credit card balance -->
									<div class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.question_open_credit_card_balance')}}</p>
									</div>
									<!-- Has open credit card balance -->
									<validation cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_has_open_credit_card_balance_1" name="cust_has_open_credit_card_balance" value='1' v-model="request_loc.has_open_credit_card_balance" />
												<label for="radio_has_open_credit_card_balance_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_has_open_credit_card_balance_0" name="cust_has_open_credit_card_balance" value='0' v-model="request_loc.has_open_credit_card_balance" />
												<label for="radio_has_open_credit_card_balance_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
								</div>
								<!-- Open credit card balances -->
								<div v-show="request_loc.has_open_credit_card_balance == 1" class="flex flex-col items-center">
									<div v-for="(open_balance, nr) in open_balances_loc" :key="nr" class="w-full max-w-text p-2 m-1 mt-4 border-3 rounded-3xl border-color-2">
										<!-- Issuer -->
										<validation>
											<div class="flex flex-row gap-2 items-end">
												<ejs-combobox :name="'cust_issuer_' + nr" :dataSource='issuers' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.issuer') + ' ' + (nr + 1)" :showClearButton="false" :allowCustom="false" v-model:value="open_balance.issuer"></ejs-combobox>
												<button type="button" class="eny-btn-blue px-4 pb-1 h-10 font-semibold text-2xl" @click="deleteOpenBalance(nr)">x</button>
											</div>
										</validation>
										<!-- Month rate -->
										<validation>
											<div class="flex flex-row">
												<ejs-numerictextbox :id="'cust_balance_monthly_rate_' + nr" :name="'cust_balance_monthly_rate_' + nr" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.monthly_rate')" v-model:value="open_balance.month_rate"></ejs-numerictextbox>
												<text-box-extension :label="$t('eny.chf')" />
											</div>
										</validation>
										<!-- Open balance -->
										<validation>
											<ejs-numerictextbox :id="'cust_balance_open_balance_' + nr" :name="'cust_balance_open_balance_' + nr" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.open_balance')" v-model:value="open_balance.open_balance"></ejs-numerictextbox>
										</validation>
									</div>
									<!-- Add additional open balance -->
									<div v-show="open_balances_loc.length < 3" class="w-full px-10 md:px-20 pt-6 flex flex-row justify-center">
										<button type="button" class="eny-btn-blue px-8 py-2 font-bold" @click="addOpenBalance">{{$t('eny.other_existing_credit')}}</button>
									</div>
								</div>
							</div>
						</form>
					</panel>
					<panel :title="$t('eny.add_expenses')" addclass="mt-4">
						<form id="add-expenses-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Number of dependent children -->
									<div class="w-full max-w-text">
										<ejs-combobox id='cust_number_children' name='cust_number_children' :dataSource='children_counts' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.number_of_dependent_children')" :showClearButton="false" :allowCustom="false" v-model:value="children_loc.length" :select='selectChildrenNumber'></ejs-combobox>
									</div>
									<!-- Children age -->
									<div id="children_age" class="w-full max-w-text">
										<validation v-for="(child, nr) in children_loc" :key="nr" cssClass="mt-1">
											<div class="e-float-input !rounded-full !border-3 !border-color-2">
												<div class="flex flex-row gap-5 h-9">
													<div class="grow flex items-center pl-5">
														<ejs-slider :name="'childage_' + nr" v-model:value="child.age" type="MinRange" min="0" max="25" step="1"></ejs-slider>
													</div>
													<div class="flex flex-col items-center">
														<div class="bg-color-2 text-color-5 font-normal text-base rounded-full flex items-center h-full">
															<div class="flex flex-row px-4 w-24 justify-between">
																<div>{{child.age}}</div>
																<div>{{$t('eny.years')}}</div>
															</div>
														</div>
													</div>
												</div>
												<label class="e-float-text !text-color-2 !text-xs" style="transform: translate3d(-5px, -40px, 0) scale(1);">{{$t('eny.child_age', {nr: nr + 1})}}</label>
											</div>
										</validation>
									</div>
									<!-- Question pay for childcare -->
									<div v-if="hasChildren" class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.question_pay_for_childcare')}}</p>
									</div>
									<!-- Pay for childcare -->
									<validation v-if="hasChildren" cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_pay_for_childcare_1" name="cust_pay_for_childcare" value='1' v-model="request_loc.pay_for_childcare" />
												<label for="radio_pay_for_childcare_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_pay_for_childcare_0" name="cust_pay_for_childcare" value='0' v-model="request_loc.pay_for_childcare" />
												<label for="radio_pay_for_childcare_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
									<!-- Child care monthly -->
									<validation v-show="hasChildren && request_loc.pay_for_childcare == 1" cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="cust_child_care_monthly" name="cust_child_care_monthly" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.child_care_monthly')" v-model:value="request_loc.child_care"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
									<!-- Question pay alimony -->
									<div v-if="hasChildren" class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.question_pay_alimony')}}</p>
									</div>
									<!-- Pay alimony -->
									<validation v-if="hasChildren" cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_pay_alimony_1" name="cust_pay_alimony" value='1' v-model="request_loc.pay_alimony" />
												<label for="radio_pay_alimony_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_pay_alimony_0" name="cust_pay_alimony" value='0' v-model="request_loc.pay_alimony" />
												<label for="radio_pay_alimony_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
									<!-- Alimony monthly -->
									<validation v-show="hasChildren && request_loc.pay_alimony == 1" cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="cust_alimony_monthly" name="cust_alimony_monthly" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.alimony_monthly')" v-model:value="request_loc.alimony"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
										</div>
									</validation>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div v-if="allow_navigation" class="w-full px-10 md:px-20 py-3 2xl:pt-5 flex flex-row justify-center gap-2 sm:gap-6">
						<email-button />
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { MaskedTextBoxComponent, FormValidator, NumericTextBoxComponent, SliderComponent } from '@syncfusion/ej2-vue-inputs';
import { ComboBoxComponent } from "@syncfusion/ej2-vue-dropdowns";
import { ProgressBarComponent }  from "@syncfusion/ej2-vue-progressbar";
import Panel from "../../Base/Panel.vue";
import Validation from "../../Base/Validation.vue";
import OfferRequest from "./Request.vue";
import TextBoxExtension from "../../Helper/TextBoxExtension.vue";
import SendEmailButton from "../../Base/SendEmailButton.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from "../../hooks/useUtils";

export default {
	name: "CustomerExpenses",
	components: {
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		"ejs-combobox": ComboBoxComponent,
		'ejs-slider' : SliderComponent,
		'ejs-numerictextbox': NumericTextBoxComponent,
		'ejs-progressbar': ProgressBarComponent,
		'panel': Panel,
		'validation': Validation,
		'offer-request': OfferRequest,
		'text-box-extension': TextBoxExtension,
		'email-button': SendEmailButton,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		const { sortList } = useUtils();
		return {
			showNotification,
			hideNotification,
			sortList,
		}
	},
	data() {
		return {
			// data variables
			request_loc: {},
			expensesFormValidator: {},
			open_loans_loc: [],
			open_balances_loc: [],
			existingObligationsFormValidator: {},
			children_loc: [],
			addExpensesFormValidator: {},
			// controls' data
			living_condition_types: JSON.parse(this.$t('eny.living_condition_types')),
			monthly_housing_expenses_list: JSON.parse(this.$t('eny.monthly_housing_expenses_list')),
			transport_to_work_types:  JSON.parse(this.$t('eny.transport_to_work_types')),
			fields : { text: 'label', value: 'value' },
			banks: this.sortList(JSON.parse(this.$t('eny.banks')), 'value', 'label', 'ot'),
			issuers: this.sortList(JSON.parse(this.$t('eny.issuers')), 'value', 'label', 'ot'),
			children_counts: JSON.parse(this.$t('eny.children_counts')),
		};
	},
	mounted() {
		this.request_loc = this.request;
		if (this.request_loc.transport_to_work_type !== 'cc') {
			this.transport_to_work_types = this.transport_to_work_types.filter(
				(item) => item.value !== 'cc'
			);
		}

		const expensesFormOptions = {
			rules: {
				cust_living_condition: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.living_condition')})] },
				cust_monthly_housing_expenses: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_housing_expenses')})] },
				housing_property: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.housing_type')})] },
				cust_health_insurance: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.health_insurance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_costs_out_of_town_meals: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.costs_out_of_town_meals')})] },
				cust_transport_to_work_type: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.means_of_transport_to_work')})] },
			},
			customPlacement: this.showValidationError,
		};
		this.expensesFormValidator = new FormValidator("#expenses-form", expensesFormOptions);

		this.open_loans_loc = this.open_loans;
		this.open_balances_loc = this.open_balances;
		const existingObligationsFormOptions = {
			rules: {
				cust_has_open_loan: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_loan_bank_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.bank')})] },
				cust_monthly_rate_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_open_balance_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_loan_bank_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.bank')})] },
				cust_monthly_rate_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_open_balance_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_loan_bank_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.bank')})] },
				cust_monthly_rate_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_open_balance_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_has_open_credit_card_balance: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_issuer_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.issuer')})] },
				cust_balance_monthly_rate_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_balance_open_balance_0: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_issuer_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.issuer')})] },
				cust_balance_monthly_rate_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_balance_open_balance_1: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_issuer_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.issuer')})] },
				cust_balance_monthly_rate_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_rate')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
				cust_balance_open_balance_2: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.open_balance')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
			},
			customPlacement: this.showValidationError,
		};
		this.existingObligationsFormValidator = new FormValidator("#existing-obligations-form", existingObligationsFormOptions);

		this.children_loc = this.children;
		const addExpensesFormOptions = {
			rules: {
				childage_0: { min: [0, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.age')})] },
				childage_1: { min: [0, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.age')})] },
				childage_2: { min: [0, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.age')})] },
				childage_3: { min: [0, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.age')})] },
				childage_4: { min: [0, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.age')})] },
				cust_pay_alimony: { required: [true, this.$t('eny.field_notempty_error_msg')] },
				cust_alimony_monthly: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.alimony_monthly')})], number: [true, this.$t('eny.field_onlynumber_error_msg')] },
			},
			customPlacement: this.showValidationError,
		};
		this.addExpensesFormValidator = new FormValidator("#add-expenses-form", addExpensesFormOptions);

		this.fetchConfig();

		this.$store.dispatch('customer/update_offer_step', 3);
	},
	computed: {
		...mapGetters('customer', ['request', 'open_loans', 'open_balances', 'allowance', 'children', 'success', 'message', 'loading']),
		...mapGetters('config', ['config']),
		allow_navigation: function () {
			return this.request.id;
		},
		hasChildren() {
			return this.children_loc.length > 0;
		},
	},
	methods: {
		...mapActions('config', ['fetchConfig']),
		prevStep: function() {
			const prevPage = this.request.civil_status == '1' ? '/offer/customer_partner_income' : '/offer/customer_income';
			this.$router.push(prevPage);
		},
		nextStep: function() {
			if (this.validate()) {
				// cost of transport to work is 0 if walking on foot driving a velo, otherwise it is set to 150 chf
				this.request_loc.commute = ['of', 'vl'].includes(this.request_loc.transport_to_work_type) ? 0 : 150;
				this.$store.dispatch('customer/store_expenses', {
					request: this.request_loc,
					open_loans: this.open_loans_loc, open_balances: this.open_balances_loc,
					children: this.children_loc
				})
				.then(() => {
					let nextPage = '/offer/confirmation'
					if (this.success) {
						const recommendation = parseInt(this.request.recommendation) || 0;
						const allowanceAmount = parseInt(this.allowance.amount) || 0;
						const goToConfirmation =
							(recommendation >= 0 || this.config.accept_negative_recommendation) &&
							(allowanceAmount >= 0 || this.config.accept_negative_intrum);
						nextPage = goToConfirmation ? '/offer/confirmation' : '/offer/rejection';
					}
					this.$router.push(nextPage);
				})
			}
		},
		validate: function() {
			let ok = true;
			// expenses check
			const expensesFieldsToCheck = ['cust_living_condition', 'cust_monthly_housing_expenses', 'housing_property', 'cust_health_insurance', 'cust_transport_to_work_type'];
			expensesFieldsToCheck.forEach(item => ok &= this.expensesFormValidator.validate(item))
			// existing obligation check
			const existingObligationFieldsToCheck = ['cust_has_open_loan', 'cust_has_open_credit_card_balance'];
			if (this.request_loc.has_open_loan == 1) {
				const openLoansNr = this.open_loans_loc.length;
				for (let i = 0; i < openLoansNr; ++i) {
					existingObligationFieldsToCheck.push('cust_loan_bank_' + i, 'cust_monthly_rate_' + i, 'cust_open_balance_' + i);
				}
			}
			if (this.request_loc.has_open_credit_card_balance == 1) {
				const openBalancesNr = this.open_balances_loc.length;
				for (let i = 0; i < openBalancesNr; ++i) {
					existingObligationFieldsToCheck.push('cust_issuer_' + i, 'cust_balance_monthly_rate_' + i, 'cust_balance_open_balance_' + i);
				}
			}
			existingObligationFieldsToCheck.forEach(item => ok &= this.existingObligationsFormValidator.validate(item))
			// additional expenses check
			const childrenNr = this.children_loc.length;
			var addExpensesfieldsToCheck = childrenNr ? ['cust_pay_alimony'] : [];
			for (let i = 0; i < childrenNr; ++i) {
				addExpensesfieldsToCheck.push('childage_' + i);
			}
			if (this.request_loc.pay_alimony == 1) {
				addExpensesfieldsToCheck.push('cust_alimony_monthly');
			}
			addExpensesfieldsToCheck.forEach(item => ok &= this.addExpensesFormValidator.validate(item))

			return ok;
		},
		addOpenLoan: function() {
			this.open_loans_loc.push({bank: "", month_rate: "", open_balance: ""});
		},
		deleteOpenLoan: function(index) {
			this.open_loans_loc.splice(index, 1);
		},
		addOpenBalance: function() {
			this.open_balances_loc.push({issuer: "", month_rate: "", open_balance: ""});
		},
		deleteOpenBalance: function(index) {
			this.open_balances_loc.splice(index, 1);
		},
		selectChildrenNumber: function(sel) {
			const number = parseInt(sel.itemData.value) || 0;
			const curLength = this.children_loc.length;
			const diff = number - curLength;
			if (diff > 0) {
				for (let i = 0; i < diff; ++i) {
					this.children_loc.push({age: "0"});
				}
			}
			else if (diff < 0) {
				this.children_loc.splice(diff);
			}
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group').querySelector('.error-element').appendChild(errorElement);
		},
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
<style>
</style>
